// Copyright (c) 2017 Deere & Company

import actions from '../../actions-list';

export const updateFilterBy = filterText => ({
    data: filterText,
    type: actions.UPDATE_TCSM_AUDIT_LIST_FILTER_BY
});

export const updateSortBy = option => ({
    data: option,
    type: actions.UPDATE_TCSM_AUDIT_LIST_SORT_BY
});

export const updateSortDirection = direction => ({
    data: direction,
    type: actions.UPDATE_TCSM_AUDIT_LIST_SORT_DIRECTION
});



// WEBPACK FOOTER //
// ./src/tcsm/audits/action-creators/search-filters.js